import permissions from '@/constants/permissions';
import apiSheet from '@/services/api/sheet';

import { setContext, setExtra } from '@sentry/vue';

import { getField, updateField } from 'vuex-map-fields';

import merge from 'lodash.merge';

const tableOfContentsList = (items) => {
    return items;
};

const emptySheetOne = () => {
    return {
        meeting: {
            familyGuide: {
                representatives: []
            },
            previousEditions: {
                helpReceived: null,
                helpAmount: 0,
                howDoYouRemember: null,
                whatHasChanged: null,
                hasImpactChange: null,
                impactOnLife: null,
                attemptToGetOutOfSituation: null,
                attemptToGetOutOfSituationReason: null,
                getOutOfSituationReasonExplain: null
            },
            familyHistory: {
                everydayLife: null,
                ledToSituation: null,
                lifeLookLikeBefore: null,
                toOvercomeDifficulties: null
            },
            familyResources: {
                whatYouEnjoy: null,
                solutions: null,
                familySkills: null,
                gratefulFor: null,
                dreamAbout: null,
                thoughtsAboutFuture: null
            },
            barriers: {
                needTheMost: null,
                workOn: null,
                aboutSixty: null,
                needOthersHelp: null,
                pandemic: null
            },
            socialSeparation: {
                howOften: null,
                someoneWhoVisits: null
            },
            seniorsPack: {
                visiting: null,
                howOften: null,
                contactWays: null,
                freeTimeSpending: null,
                takePartIn: null
            },
            possessions: {
                livingConditions: {
                    type: null,
                    roomsAmount: 0,
                    bath: false,
                    kitchen: false
                },
                energyExclusion: [],
                hasFarm: null,
                hasVehicle: null,
                connection: [],
                internetUsage: null,
                computerOrTabletNumber: null,
                remoteEducation: null,
                remoteEducationBarriers: null,
                otherRemoteEducationBarriers: null,
                remoteEducationNumberOfExcludedChildren: null,
                canAffordHeatingTheHouse: null
            },
            maintenanceExpenses: {
                costs: {
                    rent: null,
                    electricity: null,
                    gas: null,
                    water: null,
                    internet: null,
                    phone: null
                },
                heating: [],
                details: {
                    type: null,
                    tonsPerYear: 0,
                    costPerTon: null,
                    costPerYear: null,
                    costPerMonth: null
                },
                otherHeating: {
                    type: null,
                    tonsPerYear: 0,
                    costPerTon: null,
                    costPerYear: null,
                    costPerMonth: null
                },
                isSpendingNursery: null,
                nurseryCost: '',
                takeJob: null,
                totalAmount: null,
                transportCost: null,
                transportExpenses: '',
                transportExpensesJustification: null
            },
            expensesForMedicine: {
                hasIllMembers: null,
                hasDisabledMember: null,
                hasDisabledMembers: null,
                members: [],
                illMembers: [],
                disabledMembers: [],
                selectedMembers: [],
                selectedIllMembers: [],
                selectedDisabledMembers: [],
                coveredCosts: null,
                coveredCostsExplain: null,
                difficultAccessToMedicine: null,
                difficultAccessToMedicineReason: null,
                totalMedicineAmount: null,
                difficultAccessToMedicalAssistance: null
            },
            doctorsPack: {
                checkedMedicalAreas: [],
                receivingMedicalHelp: null,
                receivingMedicalHelpExplain: null,
                typeOfHelp: null,
                otherMedicalAreas: null,
                medicHelp: null,
                members: [],
                problemDescription: null,
                problemSince: null,
                problemFixingAttempt: null,
                problemFixingAttemptDescription: null,
                onlineHelpConsent: null
            },
            credits: {
                hasCredits: null,
                hasArrears: null,
                creditReason: null,
                regularCreditRepair: null,
                hasLawProblems: null,
                arrearsAmount: null,
                typeOfArrears: null,
                creditReasonExplanation: null,
                creditDetails: {
                    creditAmount: null,
                    remainsToRepair: null,
                    creditYear: null,
                    monthCreditAmount: null
                },
                totalAmount: '',
                hasInformalLiability: null,
                informalLiabilityDescription: null,
                informalLiabilityReason: null,
                informalLiabilityReasonOther: null,
                informalLiabilityForDecentLivingConditions: null,
                informalLiabilityDetails: {
                    liabilityAmount: null,
                    liabilityRemainsToRepair: null,
                    liabilityYear: null,
                    monthLiabilityAmount: null
                },
                informalLiabilityPending: null,
                informalLiabilityTotalAmount: '',
                creditForDecentLivingConditions: null,
                arrearsOther: ''
            },
            lawyersPack: {
                selectedLawCases: [],
                otherLawCase: null,
                selectedLawyerServices: null,
                lawyerHelp: null,
                freeLawyerHelp: null,
                paidLawyerHelp: null,
                lawyerHelpReason: null,
                lawProblemSelfHelp: null,
                lawProblemSelfHelpDescription: null,
                onlineHelpConsent: null
            },
            cashReceipts: {
                isMembersWork: null,
                activeMembers: [],
                members: [],
                chosenSources: [],
                chosenSourceDetails: [],
                otherHelp: null,
                otherHelpExplain: null,
                totalReceiptsAmount: 0,
                totalAnotherReceiptsAmount: 0,
                chosenSourceOtherDescription: null,
                family500plusImprovement: null,
                noticePeriod: null,
                noticePeriodMembers: [],
                helpFromFamilyAndFriends: null,
                helpFromFamilyAndFriendsDescription: null,
                hasSavings: null,
                sustainedBySavings: null
            },
            jobless: {
                isReadyForWork: null,
                selectedMembers: [],
                members: [],
                aboutSixty: null
            },
            consents: {
                personalData: null,
                meetingsAfterFinal: null,
                giftGiverContact: null,
                preliminaryMediaContact: null,
                mediaDisclosureAgreement: null,
                couldFamilyStoryBePresentedInMedia: null
            },
            volunteers: {
                date: null
            }
        },
        reflection: {
            meetingSummary: {
                expectations: '',
                likeInFamily: '',
                whatWorried: '',
                attitude: '',
                canDeal: '',
                isDisturbed: null,
                canDealWithProblems: null
            },
            seniorReflection: {
                isLoneliness: null,
                readyToChange: null,
                hasPrecludeFactors: null,
                precludeFactors: [],
                otherFactors: null
            },
            resources: {
                hasResources: [],
                otherResources: '',
                strengths: '',
                needOtherResourcesText: '',
                actionsToEffects: '',
                hasStrengths: null,
                needOtherResources: null
            },
            barriers: {
                competence: [],
                beliefs: [],
                condition: [],
                support: [],
                competenceOtherText: '',
                beliefsOtherText: '',
                conditionOtherText: '',
                supportOtherText: '',
                importantCompetence: [],
                importantBeliefs: [],
                importantCondition: [],
                importantSupport: [],
                breakCompetence: [],
                breakBeliefs: [],
                breakCondition: [],
                breakSupport: [],
                influencedCompetence: [],
                influencedBeliefs: [],
                influencedCondition: [],
                influencedSupport: [],
                hasInfluence: null,
                cantBreakBarriers: null,
                barriersInFamily: null,
                barriersInFamilyOther: null
            },
            solutionSummary: {
                whatHelp: ''
            }
        },
        decision: {
            isTurnOn: null,
            specialIncluding: null,
            includeToSpecialProjects: [],
            turnOn: {
                helpCriteria: [],
                whyIncludeAgain: null
            },
            nonInclusion: {
                reason: [],
                otherReason: null,
                explanation: null
            }
        }
    };
};

const emptySheetTwo = () => {
    return {
        firstMeeting: {
            askedQuestions: null,
            questionsList: ''
        },
        changedNames: {
            newNames: []
        },
        food: {
            chosenProducts: [],
            productsForBabies: '',
            otherProducts: '',
            hasDietaryRequirements: null,
            dietaryRequirements: ''
        },
        cleaningProducts: {
            chosenProducts: [],
            childrenProducts: '',
            otherProducts: '',
            hasSpecialRequirements: null,
            specialRequirements: '',
            whatLiquidCleaningProducts: null
        },
        clothing: {
            needClothes: null,
            chosenClothesDetails: [],
            chosenClothesMembers: [],
            needFootwear: null,
            chosenFootwearMembers: [],
            chosenFootwearDetails: []
        },
        schoolSupplies: {
            needSchoolSupplies: null,
            selectedSupplies: [],
            anotherSchoolSupplies: ''
        },
        apartmentEquipment: {
            selectedEquipment: [],
            anotherEquipment: [],
            notes: ''
        },
        householdAppliances: {
            selectedAppliances: [],
            anotherAppliances: [],
            notes: '',
            vitalElectronicAppliances: [],
            vitalElectronicAppliancesNotes: '',
            vitalElectronicAppliancesNeeds: null
        },
        otherMaterialNeeds: {
            hasOtherNeeds: null,
            selectedMaterialNeeds: [],
            fuelType: null,
            fuelAmount: '',
            otherFuelType: '',
            anotherMaterialNeeds: [],
            anotherMaterialNeedsNotes: ''
        },
        intangibleNeeds: {
            hasIntangibleNeeds: null,
            intangibleNeedsList: []
        },
        specialGifts: {
            members: [],
            giftsNotes: ''
        },
        importantNeeds: {
            list: [
                {
                    need: '',
                    note: '',
                    noteNotNeeded: false
                },
                {
                    need: '',
                    note: '',
                    noteNotNeeded: false
                },
                {
                    need: '',
                    note: '',
                    noteNotNeeded: false
                }
            ]
        },
        consents: {
            personalDataConsent: null,
            donorContactConsent: null,
            mediaContactConsent: null,
            date: ''
        },
        volunteers: {
            date: '',
            volunteerStatement: null
        },
        reflection: {
            notes: ''
        }
    };
};

export default {
    namespaced: true,
    state: {
        tableOfContents: {
            currentRouteName: null,
            currentSelectorName: null,
            list: []
        },
        hiddenSelectorsList: [],
        loadedSheetOne: {},
        startSection: {},
        saveTempSheet: false,
        sheetOneResource: null,
        sheetTwoResource: null,
        partialSheetData: null,
        partialSheetDataError: false,
        sheetOne: emptySheetOne(),
        sheetTwo: emptySheetTwo(),
        isSaveDraftVisible: true,
        exclusionReasons: [],
        sheetPermissions: {},
        sheetAuditComments: null,
        removeRepresentative: false,
        allowModifyFamilyGuide: null,
        sheetMeetingQuestions: null,
        sheetReflectionQuestions: null,
        sheetDecisionQuestions: null,
        sheetNeedsQuestions: null,
        sheetDescriptionQuestions: null
    },
    getters: {
        getRepresentatives (state) {
            return state.sheetOne.meeting.familyGuide.representatives;
        },
        getMeetingFields (state) {
            return state.sheetOne.meeting;
        },
        getReflectionFields (state) {
            return state.sheetOne.reflection;
        },
        getFamilyGuideField (state) {
            return getField(state.sheetOne.meeting.familyGuide);
        },
        getPreviousEditionsField (state) {
            return getField(state.sheetOne.meeting.previousEditions);
        },
        getFamilyHistoryField (state) {
            return getField(state.sheetOne.meeting.familyHistory);
        },
        getFamilyResourcesField (state) {
            return getField(state.sheetOne.meeting.familyResources);
        },
        getBarriersField (state) {
            return getField(state.sheetOne.meeting.barriers);
        },
        getSocialSeparationField (state) {
            return getField(state.sheetOne.meeting.socialSeparation);
        },
        getSeniorsPackField (state) {
            return getField(state.sheetOne.meeting.seniorsPack);
        },
        getPossessionsField (state) {
            return getField(state.sheetOne.meeting.possessions);
        },
        getMaintenanceExpensesField (state) {
            return getField(state.sheetOne.meeting.maintenanceExpenses);
        },
        getExpensesForMedicineField (state) {
            return getField(state.sheetOne.meeting.expensesForMedicine);
        },
        getDoctorsPackField (state) {
            return getField(state.sheetOne.meeting.doctorsPack);
        },
        getCreditsField (state) {
            return getField(state.sheetOne.meeting.credits);
        },
        getLawyersPackField (state) {
            return getField(state.sheetOne.meeting.lawyersPack);
        },
        getCashReceiptsField (state) {
            return getField(state.sheetOne.meeting.cashReceipts);
        },
        getJoblessField (state) {
            return getField(state.sheetOne.meeting.jobless);
        },
        getTableOfContentsList (state) {
            return state.tableOfContents.list;
        },
        getCurrentSelectorName (state) {
            return state.tableOfContents.currentSelectorName;
        },
        getHiddenSelectorsList (state) {
            return state.hiddenSelectorsList;
        },
        getSheetOne (state) {
            return state.sheetOne;
        },
        getReflectionBarriersField (state) {
            return getField(state.sheetOne.reflection.barriers);
        },
        getSeniorReflectionField (state) {
            return getField(state.sheetOne.reflection.seniorReflection);
        },
        getReflectionResourcesField (state) {
            return getField(state.sheetOne.reflection.resources);
        },
        getReflectionMeetingSummaryField (state) {
            return getField(state.sheetOne.reflection.meetingSummary);
        },
        getReflectionSolutionSummaryField (state) {
            return getField(state.sheetOne.reflection.solutionSummary);
        },
        getDecision (state) {
            return getField(state.sheetOne.decision);
        },
        getDecisionFields (state) {
            return state.sheetOne.decision;
        },
        getDecisionTurnOn (state) {
            return getField(state.sheetOne.decision.turnOn);
        },
        getConsentsField (state) {
            return getField(state.sheetOne.meeting.consents);
        },
        getVolunteersField (state) {
            return getField(state.sheetOne.meeting.volunteers);
        },
        getMeetingVolunteers (state) {
            return state.sheetOne.meeting.volunteers;
        },
        getDecisionNonInclusion (state) {
            return getField(state.sheetOne.decision.nonInclusion);
        },
        getFirstMeetingField (state) {
            return getField(state.sheetTwo.firstMeeting);
        },
        getChangedNamesField (state) {
            return getField(state.sheetTwo.changedNames);
        },
        getSheetOneResource (state) {
            return state.sheetOneResource;
        },
        getSheetTwoResource (state) {
            return state.sheetTwoResource;
        },
        getFoodFields (state) {
            return getField(state.sheetTwo.food);
        },
        getCleaningProductsFields (state) {
            return getField(state.sheetTwo.cleaningProducts);
        },
        getClothingFields (state) {
            return getField(state.sheetTwo.clothing);
        },
        getNewNames (state) {
            return state.sheetTwo.changedNames.newNames;
        },
        getSchoolSuppliesFields (state) {
            return getField(state.sheetTwo.schoolSupplies);
        },
        getApartmentEquipmentFields (state) {
            return getField(state.sheetTwo.apartmentEquipment);
        },
        getHouseholdAppliances (state) {
            return getField(state.sheetTwo.householdAppliances);
        },
        getOtherMaterialNeedsFields (state) {
            return getField(state.sheetTwo.otherMaterialNeeds);
        },
        getIntangibleNeedsFields (state) {
            return getField(state.sheetTwo.intangibleNeeds);
        },
        getSpecialGiftsFields (state) {
            return getField(state.sheetTwo.specialGifts);
        },
        getImportantNeedsFields (state) {
            return getField(state.sheetTwo.importantNeeds);
        },
        getSheetTwoConsentsFields (state) {
            return getField(state.sheetTwo.consents);
        },
        getSheetTwoVolunteersFields (state) {
            return getField(state.sheetTwo.volunteers);
        },
        getSheetTwoReflectionFields (state) {
            return getField(state.sheetTwo.reflection);
        },
        getPartialSheetData (state) {
            return state.partialSheetData;
        },
        getSheetTwo (state) {
            return state.sheetTwo;
        },
        getIsSaveDraftVisible (state) {
            return state.isSaveDraftVisible;
        },
        getExclusionReasons (state) {
            return state.exclusionReasons;
        },
        getSheetPermissions: (state) => state.sheetPermissions,
        getSheetAuditComments: (state) => state.sheetAuditComments,
        getRemoveRepresentative: (state) => state.removeRepresentative,
        getAllowModifyFamilyGuide: (state) => state.allowModifyFamilyGuide,
        getMeetingQuestions: (state) => state.sheetMeetingQuestions,
        getFamilyGuideQuestions: (state) => state.sheetMeetingQuestions.family_guide,
        getPreviousEditionsQuestions: (state) => state.sheetMeetingQuestions.previous_editions,
        getFamilyHistoryQuestions: (state) => state.sheetMeetingQuestions.family_history,
        getFamilyResourcesQuestions: (state) => state.sheetMeetingQuestions.family_resources,
        getFamilyBarriersQuestions: (state) => state.sheetMeetingQuestions.barriers,
        getSocialSeparationQuestions: (state) => state.sheetMeetingQuestions.social_separation,
        getSeniorPackQuestions: (state) => state.sheetMeetingQuestions.seniors_pack,
        getPossessionsQuestions: (state) => state.sheetMeetingQuestions.possessions,
        getMaintenanceExpensesQuestions: (state) => state.sheetMeetingQuestions.maintenance_expenses,
        getExpensesForMedicineQuestions: (state) => state.sheetMeetingQuestions.expenses_for_medicine,
        getDoctorsPackQuestions: (state) =>
            state.sheetMeetingQuestions &&
      (state.sheetMeetingQuestions.medics_pack || state.sheetMeetingQuestions.doctors_pack),
        getCreditsQuestions: (state) => state.sheetMeetingQuestions.credits,
        getLawyersPackQuestions: (state) => state.sheetMeetingQuestions.lawyers_pack,
        getCashReceiptsQuestions: (state) => state.sheetMeetingQuestions.cash_receipts,
        getJoblessQuestions: (state) =>
            state.sheetMeetingQuestions && state.sheetMeetingQuestions.jobless,
        getConsentsQuestions: (state) => state?.sheetMeetingQuestions?.consents,
        getVolunteersQuestions: (state) => state.sheetMeetingQuestions.volunteers,
        getMeetingSummaryQuestions: (state) => state.sheetReflectionQuestions.meeting_summary,
        getResourcesQuestions: (state) => state.sheetReflectionQuestions.resources,
        getBarriersQuestions: (state) => state.sheetReflectionQuestions.barriers,
        getSolutionSummaryQuestions: (state) => state.sheetReflectionQuestions.solution_summary,
        getSeniorReflectionQuestions: (state) => state.sheetReflectionQuestions.senior_reflection,
        getDecisionQuestions: (state) => state.sheetDecisionQuestions,
        getFirstMeetingQuestions: (state) => state.sheetNeedsQuestions.first_meeting,
        getChangeNamesQuestions: (state) => state.sheetNeedsQuestions.changed_names,
        getFoodQuestions: (state) => state.sheetNeedsQuestions.food,
        getCleaningProductsQuestions: (state) => state.sheetNeedsQuestions.cleaning_products,
        getClothingQuestions: (state) => state.sheetNeedsQuestions.clothing,
        getSchoolSuppliesQuestions: (state) => state.sheetNeedsQuestions.school_supplies,
        getApartmentEquipmentQuestions: (state) => state.sheetNeedsQuestions.apartment_equipment,
        getHouseholdAppliancesQuestions: (state) => state.sheetNeedsQuestions.household_appliances,
        getOtherMaterialNeedsQuestions: (state) => state.sheetNeedsQuestions.other_material_needs,
        getIntangibleNeedsQuestions: (state) => state.sheetNeedsQuestions.intangible_needs,
        getSpecialGiftsQuestions: (state) => state.sheetNeedsQuestions.special_gifts,
        getNeedsConsentsQuestions: (state) => state.sheetNeedsQuestions.consents,
        getNeedsVolunteersQuestions: (state) => state.sheetNeedsQuestions.volunteers,
        getNeedsVolunteerStatementQuestions: (state) => state.sheetNeedsQuestions.volunteerStatement,
        getReflectionQuestions: (state) => state.sheetNeedsQuestions.reflection,
        getImportantNeedsQuestions: (state) => state.sheetNeedsQuestions.important_needs,
        getSheetDescriptionQuestions: (state) => state.sheetDescriptionQuestions,
        getPartialSheetDataError: (state) => state.partialSheetDataError
    },
    mutations: {
        updateFamilyGuideField (state, field) {
            updateField(state.sheetOne.meeting.familyGuide, field);
        },
        updatePreviousEditionsField (state, field) {
            updateField(state.sheetOne.meeting.previousEditions, field);
        },
        updateFamilyHistoryField (state, field) {
            updateField(state.sheetOne.meeting.familyHistory, field);
        },
        updateFamilyResourcesField (state, field) {
            updateField(state.sheetOne.meeting.familyResources, field);
        },
        updateBarriersField (state, field) {
            updateField(state.sheetOne.meeting.barriers, field);
        },
        updateSocialSeparationField (state, field) {
            updateField(state.sheetOne.meeting.socialSeparation, field);
        },
        updateSeniorsPackField (state, field) {
            updateField(state.sheetOne.meeting.seniorsPack, field);
        },
        updatePossessionsField (state, field) {
            updateField(state.sheetOne.meeting.possessions, field);
        },
        updateMaintenanceExpensesField (state, field) {
            updateField(state.sheetOne.meeting.maintenanceExpenses, field);
        },
        updateExpensesForMedicineField (state, field) {
            updateField(state.sheetOne.meeting.expensesForMedicine, field);
        },
        updateDoctorsPackField (state, field) {
            updateField(state.sheetOne.meeting.doctorsPack, field);
        },
        updateCreditsField (state, field) {
            updateField(state.sheetOne.meeting.credits, field);
        },
        updateLawyersPackField (state, field) {
            updateField(state.sheetOne.meeting.lawyersPack, field);
        },
        updateCashReceiptsField (state, field) {
            updateField(state.sheetOne.meeting.cashReceipts, field);
        },
        updateJoblessField (state, field) {
            updateField(state.sheetOne.meeting.jobless, field);
        },
        updateConsentsField (state, field) {
            updateField(state.sheetOne.meeting.consents, field);
        },
        updateVolunteersField (state, field) {
            updateField(state.sheetOne.meeting.volunteers, field);
        },
        setMeetingVolunteers (state) {
            state.sheetOne.meeting.volunteers = emptySheetOne().meeting.volunteers;
        },
        addToCList (state, payload) {
            state.tableOfContents.list = payload;
        },
        setCurrentRouteName (state, payload) {
            state.tableOfContents.currentRouteName = payload;
        },
        setCurrentSelectorName (state, payload) {
            state.tableOfContents.currentSelectorName = payload;
        },
        addHiddenSelector (state, payload) {
            if (!state.hiddenSelectorsList.includes(payload)) {
                state.hiddenSelectorsList.push(payload);
            }
        },
        removeHiddenSelector (state, payload) {
            state.hiddenSelectorsList = state.hiddenSelectorsList.filter((el) => {
                return el !== payload;
            });
        },
        setSheetOne (state, payload) {
            state.sheetOne = merge(state.sheetOne, payload);
        },
        setSheetTwo (state, payload) {
            state.sheetTwo = merge(state.sheetTwo, payload);
        },
        updateReflectionBarriersField (state, field) {
            updateField(state.sheetOne.reflection.barriers, field);
        },
        updateSeniorReflectionField (state, field) {
            updateField(state.sheetOne.reflection.seniorReflection, field);
        },
        updateReflectionResourcesField (state, field) {
            updateField(state.sheetOne.reflection.resources, field);
        },
        updateReflectionMeetingSummaryField (state, field) {
            updateField(state.sheetOne.reflection.meetingSummary, field);
        },
        updateReflectionSolutionSummaryField (state, field) {
            updateField(state.sheetOne.reflection.solutionSummary, field);
        },
        updateDecision (state, field) {
            updateField(state.sheetOne.decision, field);
        },
        updateDecisionTurnOn (state, field) {
            updateField(state.sheetOne.decision.turnOn, field);
        },
        updateDecisionNonInclusion (state, field) {
            updateField(state.sheetOne.decision.nonInclusion, field);
        },
        updateFirstMeetingField (state, field) {
            updateField(state.sheetTwo.firstMeeting, field);
        },
        updateChangedNamesField (state, field) {
            updateField(state.sheetTwo.changedNames, field);
        },
        setSheetOneResource (state, data) {
            state.sheetOneResource = data;
        },
        setSheetTwoResource (state, data) {
            state.sheetTwoResource = data;
        },
        updateFoodField (state, field) {
            updateField(state.sheetTwo.food, field);
        },
        updateCleaningProductsField (state, field) {
            updateField(state.sheetTwo.cleaningProducts, field);
        },
        updateClothingField (state, field) {
            updateField(state.sheetTwo.clothing, field);
        },
        updateSchoolSuppliesFields (state, field) {
            updateField(state.sheetTwo.schoolSupplies, field);
        },
        updateApartmentEquipmentField (state, field) {
            updateField(state.sheetTwo.apartmentEquipment, field);
        },
        updateHouseholdAppliances (state, field) {
            updateField(state.sheetTwo.householdAppliances, field);
        },
        updateOtherMaterialNeeds (state, field) {
            updateField(state.sheetTwo.otherMaterialNeeds, field);
        },
        updateIntangibleNeedsField (state, field) {
            updateField(state.sheetTwo.intangibleNeeds, field);
        },
        updateSpecialGiftsField (state, field) {
            updateField(state.sheetTwo.specialGifts, field);
        },
        updateImportantNeedsField (state, field) {
            updateField(state.sheetTwo.importantNeeds, field);
        },
        updateSheetTwoConsentsField (state, field) {
            updateField(state.sheetTwo.consents, field);
        },
        updateSheetTwoVolunteersFields (state, field) {
            updateField(state.sheetTwo.volunteers, field);
        },
        updateSheetTwoReflectionField (state, field) {
            updateField(state.sheetTwo.reflection, field);
        },
        setPartialSheetData (state, data) {
            state.partialSheetData = data;
        },
        clearSheetOne (state, data) {
            state.sheetOne = emptySheetOne();
        },
        clearSheetTwo (state, data) {
            state.sheetTwo = emptySheetTwo();
        },
        updateIsSaveDraftVisible (state, data) {
            state.isSaveDraftVisible = data;
        },
        setExclusionReasons (state, data) {
            state.exclusionReasons = data;
        },
        setSheetPermissions (state, data) {
            state.sheetPermissions = data;
        },
        setSheetAuditComments (state, data) {
            state.sheetAuditComments = data;
        },
        setRemoveRepresentative (state, payload) {
            state.removeRepresentative = payload;
        },
        setAllowModifyFamilyGuide (state, payload) {
            state.allowModifyFamilyGuide = payload;
        },
        setSheetMeetingQuestions (state, payload) {
            state.sheetMeetingQuestions = payload;
        },
        setReflectionQuestions (state, payload) {
            state.sheetReflectionQuestions = payload;
        },
        setDecisionQuestions (state, payload) {
            state.sheetDecisionQuestions = payload;
        },
        setNeedsQuestions (state, payload) {
            state.sheetNeedsQuestions = payload;
        },
        setSheetDescriptionQuestions (state, payload) {
            state.sheetDescriptionQuestions = payload;
        },
        setPartialSheetDataError (state, data) {
            state.partialSheetDataError = data;
        }
    },
    actions: {
        addTableOfContentsList (context, payload) {
            context.commit('addToCList', tableOfContentsList(payload));
        },
        saveDraftSheet (context, payload) {
            return apiSheet.postDraftSheet(payload.familyId, payload.sheetType, {
                sheet_draft_json: payload.data
            });
        },
        saveSheet (context, payload) {
            return apiSheet
                .postSheet(payload.familyId, payload.sheetType, { sheet_json: payload.data })
                .catch((err) => {
                    const { data, config } = err && err.response;
                    const { detail, status, title } = data;
                    const { data: payloadData, method, url } = config;
                    setContext('sheet', {
                        title: 'sheet',
                        sheetTitle: title,
                        detail,
                        url,
                        requestMethod: method,
                        requestStatus: status
                    });
                    setExtra('sheet_payload', {
                        payloadData
                    });
                    throw err;
                });
        },
        async loadSheet (context, payload) {
            const response = [];
            context.commit('updateIsSaveDraftVisible', true);

            const status = await apiSheet
                .getSheet(payload.familyId, payload.sheetType)
                .then(({ data }) => {
                    response[payload.sheetType] = data.data.sheet_data;
                    if (payload.sheetType === 'meeting') {
                        if (data.data.sheet_data.medicsPack) {
                            data.data.sheet_data.doctorsPack = data.data.sheet_data.medicsPack;
                            delete data.data.sheet_data.medicsPack;
                        }
                        context.commit('setAllowModifyFamilyGuide', data.data.allowed_to_modify_family_guide);
                    }

                    if (payload.sheetType === 'needs') {
                        context.commit('setSheetTwo', data.data.sheet_data);
                    } else if (payload.sheetType === 'description') {
                        context.commit('description/setDescription', data.data.sheet_data, { root: true });
                    } else {
                        context.commit('setSheetOne', response);
                    }
                    context.commit('updateIsSaveDraftVisible', false);

                    return false;
                })
                .catch((error) => {
                    return error.response.status === 404;
                });
            if (status === true) {
                const lastRequest = await apiSheet
                    .getDraftSheet(payload.familyId, payload.sheetType)
                    .then(({ data }) => {
                        response[payload.sheetType] = data.data;
                        if (payload.sheetType === 'needs') {
                            context.commit('setSheetTwo', data.data);
                        } else if (payload.sheetType === 'description') {
                            context.commit('description/setDescription', data.data, { root: true });
                        } else {
                            context.commit('setSheetOne', response);
                        }
                    })
                    .catch(async (error) => {
                        if (error.response.status === 404 && payload.sheetType === 'needs') {
                            const _data = {
                                familyId: payload.familyId,
                                sheetType: 'meeting'
                            };
                            await context.dispatch('getPartialSheetData', _data);
                        }
                        return error;
                    });
                context.commit('setAllowModifyFamilyGuide', true);
                return lastRequest;
            }
        },
        loadSheetOneResource (context, payload) {
            return apiSheet.getResourceSheet(payload.sheetId, payload.editionName).then(({ data }) => {
                context.commit('setSheetOneResource', data.data);
                context.commit('setSheetMeetingQuestions', data.data.sheet_questions.meeting);
                context.commit('setReflectionQuestions', data.data.sheet_questions.reflection);
                context.commit('setDecisionQuestions', data.data.sheet_questions.decision);
                context.commit('setSheetDescriptionQuestions', data.data.sheet_questions.description);
                context.commit(
                    'giftGivingReport/setGiftGivingReportQuestions',
                    data.data.sheet_questions.gift_giving_report,
                    { root: true }
                );
            });
        },
        loadSheetTwoResource (context, payload) {
            return apiSheet.getResourceSheet(payload.sheetId, payload.editionName).then(({ data }) => {
                context.commit('setSheetTwoResource', data.data);
                context.commit('setNeedsQuestions', data.data.sheet_questions.needs);
            });
        },
        loadFinalSheet (context, payload) {
            return apiSheet.getSheet(payload.familyId, payload.sheetType).then(({ data }) => {
                const response = [];
                response[payload.sheetType] = data.data.sheet_data;
                if (payload.sheetType === 'needs') {
                    context.commit('setSheetTwo', response[payload.sheetType]);
                    context.commit('setNeedsQuestions', data.data.sheet_questions);
                } else {
                    context.commit('setSheetOne', response);
                    if (payload.sheetType === 'meeting') {
                        context.commit('setSheetMeetingQuestions', data.data.sheet_questions);
                    }
                    if (payload.sheetType === 'reflection') {
                        context.commit('setReflectionQuestions', data.data.sheet_questions);
                    }
                }
            });
        },
        getPartialSheetData (context, payload) {
            return apiSheet
                .getPartialSheetData(payload.familyId, payload.sheetType)
                .then((data) => {
                    context.commit('setPartialSheetData', data.data.data);
                })
                .catch(() => {
                    context.commit('setPartialSheetDataError', true);
                });
        },
        getExclusionReasons (context) {
            return apiSheet.getExclusionReasons().then((data) => {
                context.commit('setExclusionReasons', data.data.data);
            });
        },
        getSheetPermissions (context, id) {
            let _areaPermission = null;
            let _nationalPermission = null;
            const results = Promise.all([
                context
                    .dispatch('auth/hasPermission', permissions.SHEET_CORRECTING_AREA, { root: true })
                    .then((res) => {
                        _areaPermission = res;
                    }),
                context
                    .dispatch('auth/hasPermission', permissions.SHEET_CORRECTING_NATIONAL, { root: true })
                    .then((res) => {
                        _nationalPermission = res;
                    })
            ]);
            results.then(() => {
                const data = {
                    familyEditionId: id,
                    type: _areaPermission || _nationalPermission ? 2 : 1
                };
                return apiSheet.getSheetPermissions(data).then((data) => {
                    context.commit('setSheetPermissions', data.data.data);
                });
            });
        },
        sendSheetCorrectionsArea (context, data) {
            return apiSheet.sendSheetCorrectionsArea(data);
        },
        sendSheetCorrectionsNational (context, data) {
            return apiSheet.sendSheetCorrectionsNational(data);
        },
        sendSheetCorrectionsVolunteer (context, data) {
            return apiSheet.sendSheetCorrectionsVolunteer(data);
        }
    }
};
